import React from 'react';
import { browserHistory } from 'react-router';
import { ComplianceDialogs } from '../../constants/Dialogs';
import { asDialog } from '../Common/Decorators';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { deleteCompliance } from '../../actions/ComplianceActionCreator';
import DialogActions from "../../actions/DialogActionCreator";

const ComplianceDeleteDialog = ({open, draft}) => {
    const { complianceId, userCount = 0 } = draft;
    if (!complianceId) { return null; } //guard: complianceId is required
    return (
        <Dialog
            title="Delete compliance"
            open={open === ComplianceDialogs.COMPLIANCE_DELETE}
            actions={[
                <FlatButton key="cancel" label="Cancel" onTouchTap={() => DialogActions.close()} />,
                <FlatButton
                    primary={true}
                    key="submit"
                    label="Delete"
                    onTouchTap={() => { deleteCompliance(complianceId); browserHistory.goBack(); DialogActions.close(); }}
                />
            ]}
        >
            This action will remove {userCount} users from this compliance and delete the compliance
        </Dialog>
    );
};

export default asDialog(ComplianceDeleteDialog, ComplianceDialogs.COMPLIANCE_DELETE);
